import { blue20, blue500, blue700, darkBlue10, darkBlue800, darkBlue900, gray100, gray400, gray50, green800, purple400, red400, white, yellow100, brandBlue, brandGreen, brandPink, brandYellow, brandPurple, brandBgBlue, brandBlue100, gray500, gray600, gray300, gray800, blue600, blue300, orange600, red800, gray200, blue50, blue100, green50, red50, yellow50, purple50, green600, green500, green400, green900, purple900, purple500, red600, red900, red500, blue900, purple800, yellow500, yellow900, yellow400 } from "./colors";
import zIndex from "./zIndex";
import transition from "./transition";
import boxShadow from "./boxShadow";
import spacing from "./spacing";
import typography from "./typography";
import breakpoints from "./breakpoints";
export default {
  palette: {
    uiBorder: gray300,
    icon: gray500,
    // deprecated
    title: gray800,
    label: gray800,
    border: gray300,
    description: gray600,
    placeholder: gray400,
    // disabled
    disabled: gray500,
    disabledText: gray600,
    disabledBackground: gray100,
    link: blue600,
    // texts
    text: {
      primaryText: gray800,
      secondaryText: gray600,
      placeholderText: gray500,
      textOnInverted: white,
      textLink: blue600,
      linkTextOnInverted: blue300,
      textOnWarning: orange600,
      textOnSuccess: green800,
      textOnError: red800,
      // deprecated
      "default": gray800,
      dark: gray800,
      secondary: gray500,
      placeholder: gray500,
      light: gray600,
      white: white,
      link: blue600,
      primary: gray800,
      input: gray800
    },
    // backgrounds
    background: {
      system: gray100,
      secondary: darkBlue10,
      white: white
    },
    surface: {
      surfaceWhite: white,
      surfaceLight: blue50,
      surfaceGray: gray100,
      surfaceDark: darkBlue900,
      surfaceWarning: yellow50,
      surfaceSuccess: green50,
      surfaceError: red50,
      surfaceDarkHighlight: darkBlue800,
      surfaceLightHighlight: blue100,
      surfaceGrayHighlight: gray200,
      surfaceWhiteHighlight: blue20,
      surfaceWarningHighlight: yellow100
    },
    // system
    error: {
      "default": red600,
      text: red900,
      hover: red500,
      background: red50,
      disabledBackground: red400,
      disabledText: red50
    },
    alert: {
      "default": yellow500,
      text: yellow900,
      hover: yellow400,
      background: yellow50
    },
    boxShadow: {
      sm: '0px 1px 3px 0px rgba(17, 24, 39, 0.08)',
      base: '0px 4px 12px 0px rgba(17, 24, 39, 0.10)',
      lg: '0px 12px 24px 0px rgba(17, 24, 39, 0.16);'
    },
    success: {
      "default": green600,
      text: green900,
      hover: green500,
      background: green50,
      disabledBackground: green400,
      disabledText: green50
    },
    info: {
      "default": purple900,
      text: purple500,
      hover: purple400,
      background: purple50
    },
    primary: {
      "default": blue600,
      text: blue900,
      hover: blue500,
      light: blue300,
      background: blue50,
      backgroundLight: blue50,
      disabled: gray200
    },
    secondary: {
      "default": blue900,
      light: purple800,
      background: gray300
    },
    action: {
      selected: gray50
    },
    // Deprecated - use primary or secondary
    brand: {
      primary: blue700,
      primaryHover: blue50,
      secondary: darkBlue900
    },
    branding: {
      brandBlue: brandBlue,
      brandGreen: brandGreen,
      brandPink: brandPink,
      brandYellow: brandYellow,
      brandPurple: brandPurple,
      brandBgBlue: brandBgBlue,
      brandBlue100: brandBlue100
    }
  },
  zIndex: zIndex,
  transition: transition,
  typography: typography,
  boxShadow: boxShadow,
  breakpoints: breakpoints,
  spacer: spacing()
};